import { render, staticRenderFns } from "./legendBox6.vue?vue&type=template&id=643379c1&scoped=true&"
import script from "./legendBox6.vue?vue&type=script&lang=js&"
export * from "./legendBox6.vue?vue&type=script&lang=js&"
import style0 from "./legendBox6.vue?vue&type=style&index=0&id=643379c1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643379c1",
  null
  
)

export default component.exports